'use client';

import { create } from 'zustand';
import { persist } from 'zustand/middleware';

/**
 * Per-group collapse state for the dashboard sidebar's labeled section groups
 * (CODE / AGENTS / TEAM / DELIVERY). Keyed by group name; absent or `false`
 * means expanded. Persisted to localStorage so a user's collapsed groups
 * survive reloads.
 */
interface SidebarSectionsState {
  collapsed: Record<string, boolean>;
  toggleSection: (group: string) => void;
}

export const useSidebarSectionsStore = create<SidebarSectionsState>()(
  persist(
    (set) => ({
      collapsed: {},
      toggleSection: (group: string) =>
        set((state) => ({
          collapsed: {
            ...state.collapsed,
            [group]: !state.collapsed[group],
          },
        })),
    }),
    {
      name: 'sidebar-sections-collapsed-v1',
    }
  )
);
